import { APP_ENV } from 'Data/constants.js'

export function getView() {
  return APP_ENV !== 'production'
}
